<template>
    <div id="AssetRequisitionList">
        <div :class="`loader${loaderClass}`" v-show="loading"></div>
        <div id="page-content-wrapper" class="admin-content-area">
            <div class="page-name">
                <div class="page-title"> Asset Requisition List</div>
                <!-- Button for Clear Cache -->
                <clear-cache-data :pageKey="[pageKey]" ></clear-cache-data>
                <div class="btn-groups pull-right">
                    <a href="javascript:void(0)" class="btn btn-secondary" v-on:click="exportCheck()">
                        <i class="fp-export"></i> Export
                    </a>
                    <router-link v-if="canAdd == true" class="btn btn-primary" v-bind:to="{name: 'AssetrequisitionCreate'}"> <i class="fp-add"> </i> Add</router-link>
                </div>
            </div>
            <template v-if="cantAccessPage === true">
                <div class="container-fluid">
                    <div class="admin-page-content asset-aquisition-list">
                        <data-table-filter-config :moduleName="'requisitionList'" ref="filterRequisition" @cancelSelection="cancelAll" :allowSameFilter="'allow'"></data-table-filter-config>
                        <div class="data-table bg-white overflow-hidden">
                          <p v-if="batchProcess" class="alert-success p-2" id="processFetchBatchMsg">Export file is in process. batch no. is {{batchNum}}. <router-link class="color-blue" v-bind:to="{name: 'BatchList'}" target="_blank" @click.native="batchProcess = 0"> Click Here</router-link> to check file status!</p>
                          <section class="bg-white data-table">
                                  <custom-pagination
                                      :page-changed="onPageChange"
                                      :per-page-changed="onPerPageChange" :moduleName="'requisitionList'" :position="'top'">
                                  </custom-pagination>

                                  <vue-good-table
                                      ref="listAssetRequisitionTable"
                                      mode="remote"
                                      title="Asset Requisition"
                                      @on-page-change="onPageChange"
                                      @on-selected-rows-change="selectionChanged"
                                      @on-select-all="onSelectAll"
                                      @on-column-filter="onColumnFilter"
                                      @on-per-page-change="onPerPageChange"
                                      @on-sort-change="onSortChange"
                                      :totalRows="totalRecords"
                                      :columns="userColumns"
                                      :rows="rows"
                                      :pagination-options="{
                                          enabled: false,
                                          position: ' both',
                                          perPage: 100,
                                          perPageDropdown:[10,20,30,40,50,100,500],
                                          dropdownAllowAll: false,
                                      }"
                                      :select-options="{
                                          enabled: true,
                                          selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                          selectionInfoClass: 'custom-class',
                                          selectionText: 'rows selected',
                                          clearSelectionText: 'clear',
                                      }"
                                      :search-options="{
                                      enabled: false,
                                      }">

                                      <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                                          <div :key="key">
                                              <div v-if="props.column.field == 'action'" class='text-center'>
                                                  <a href="javascript:void(0)" v-show="props.row.poId == null" title="Create Purchase Order"
                                                  class="mr-3" v-on:click="createPurchaseOrder(props.row.id)">
                                                      <i class="fp-receive-order"></i>
                                                  </a>
                                                  <router-link v-if="canUpdate" title="Edit Asset Requisition" class="fp-edit" v-bind:to="{name: 'AssetrequisitionEdit',params:{id:props.row.id}}"></router-link>
                                                  <!--router-link v-if="" title="Create Purchase Order" class="fp-receive-order" v-bind:to="{name: 'AssetrequisitionEdit',params:{id:props.row.id}}"></router-link-->
                                              </div>
                                              <div v-else-if="props.column.field == 'po'" class='text-center'>
                                                  <router-link target="_blank" v-if="canViewPurchaseOrder" title="View Vendor PO" class="color-blue" v-bind:to="{name: 'VendorPurchaseOrderView',params:{id:props.row.poId}, query:{from:'requisition'}}">{{props.row.po}}</router-link>
                                              </div>
                                              <div v-else>
                                                  {{props.formattedRow[props.column.field]}}
                                              </div>
                                          </div>
                                      </template>

                                      <div slot="selected-row-actions">
                                          <!--template v-if="canCreatePurchaseOrder == true">
                                              <button id="createPurchaseOrderBtn" v-on:click.prevent="createPurchaseOrder" class="btn btn-primary">Create Purchase Order</button>
                                          </template-->
                                      </div>
                                  </vue-good-table>
                                  <custom-pagination
                                      :page-changed="onPageChange"
                                      :per-page-changed="onPerPageChange">
                                  </custom-pagination>
                          </section>
                        </div>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="col-md-12">
                    <div class="error-template">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>

    </div>
</template>
<script>
import Vue from "vue";
import {commonMixins} from '../../mixins/commonMixins';
import {dataTableMixins} from '../../mixins/dataTableMixins';

import EventBus from "../event-bus";


    export default {
        name: "AssetRequisitionList",
        metaInfo: {
            // title will be injected into parent titleTemplate
            title: "Asset Requisition List | " +process.env.COPYRIGHT_NAME
        },
        mixins:[commonMixins,dataTableMixins],
        props: {
            assetReadingVal: {
                type: String,
                required: false,
                default:undefined
            }
        },
        data: () => ({
            firstLoad: 0,
            permissions: [],
            cantAccessPage: "",
            userColumns:[],
            columns: [
                {
                    label: 'Actions',
                    field: 'action',
                    sortable: false,
                },
                {
                    label: '#Requisition',
                    field: 'requisition_no',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Requisition", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: '#PO',
                    field: 'po',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Asset Model", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Ordering Facility',
                    field: 'ordering_location',
                    fpFieldType:"option",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Ordering Facility", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Required Delivery',
                    field: 'required_delivery_date',
                    fpFieldType:"date",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "MM/DD/YYYY", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Customer',
                    field: 'customer',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Customer", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Quantity',
                    field: 'qty',
                    fpFieldType:"integer",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Quantity", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Status',
                    field: 'status',
                    fpFieldType:"option",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Status", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: ['Entered', 'Approved','Received','Cancelled','Closed'],
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Updated By',
                    field: 'updated_by',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Updated By", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Updated At',
                    field: 'updated_at',
                    fpFieldType:"date",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Updated At", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
            ],
            rows: [],
            totalRecords: 0,
            serverParams: {
                columnFilters: {},
                sort: {
                    field: 'id',
                    type: 'desc',
                },
                page: 1,
                perPage: 50
            },
            reading_value: false,
            loading:false,
            assetId:"",
            canCreatePurchaseOrder:false,
            canViewPurchaseOrder:false,
            canAdd:false,
            canUpdate:false,
            pageKey:"_vehicle_requisition_list_",
            action:'list',
            batchProcess:0,
            batchNum:"",
        }),
        watch: {
            //check permission change
            permissions: function (permissions) {
                var self = this;
                if (permissions.length > 0) {
                    for (var i = 0; i < permissions.length; i++) {
                        if (permissions[i].name == 'list_asset_requisition') {
                            self.cantAccessPage = true;
                        }
                        if (permissions[i].name == 'add_purchase_order') {
                            self.canCreatePurchaseOrder = true;
                        }
                        if (permissions[i].name == 'view_purchase_order') {
                            self.canViewPurchaseOrder = true;
                        }
                        if (permissions[i].name == 'add_asset_requisition') {
                            self.canAdd = true;
                            self.canUpdate = true;
                        }
                    }
                }
            }
        },
        created: function() {

        },
        beforeDestroy(){
            // this.$root.$off('reading_opted');
        },
        mounted: function() {
            var self = this;
            //when component list directly call from url instead of in view page than call permission request
            self.getPermissions();
        },
        methods: {
            cancelAll: function (cancelAll) {
              this.$refs.listAssetRequisitionTable.unselectAllInternal();
            },
            AssetRequisitionCreatePage(){
                var self = this;
                self.$router.push("/asset-requisition/create");
            },
            exportCheck: function() {
                var self = this;
                var count = 0;
                var actionFlag = "";
                var data = this.$refs['listAssetRequisitionTable'].selectedRows;
                count = data.length;
                if(this.serverParams.selectedAll == true){
                    actionFlag = "";
                }else if(count != 0 && count <= 100){
                    actionFlag = "export";
                }
                this.exportReports(actionFlag);
            },

            selectionChanged(param) {
                var self = this;
                self.serverParams.selectedAll = false;
                if(param.selectedRows.length == 100) {
                  EventBus.$emit('clear-selection', false);
                } else {
                  EventBus.$emit('clear-all-flags', false);
                }
                return;
                // console.log(self.computed.selectedRows);
                // var rowData = self.$refs['my-table'].selectedRows;
                // console.log(rowData);
            },

            loadList() {
                var self = this;
                var selectedRow = [];
                if (self.action == 'export'){
                    var data = self.$refs['listAssetRequisitionTable'].selectedRows;
                    for (var i = 0; i < data.length; i++) {
                        selectedRow.push(self.$refs['listAssetRequisitionTable'].selectedRows[i].id)
                    }
                }
                self.loading = true;
                var fields = {
                    page: self.serverParams.page,
                    perPage: self.serverParams.perPage,
                    filters: self.serverParams.columnFilters,
                    sort: self.serverParams.sort,
                    flag:self.action,
                    selectedRow:selectedRow,
                    selectedAll:self.serverParams.selectedAll
                };
                self.firstLoad = 1;
                $.ajax({
                    url: process.env.ROOT_API + "/asset-requisition/list",
                    type: "POST",
                    data: fields,
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        if (data.code == 200) {
                            if ( self.action == "export" ||  self.action == "export_queue") {
                                if ( data.code == "201" ) {
                                    alert(data.message);
                                } else {
                                    if ( self.action == "export" ) {
                                        self.excel = data.content.web;
                                        var save = document.createElement("a");
                                        save.href = self.excel;
                                        save.download = data.content.web;
                                        save.target = "_blank";

                                        document.body.appendChild(save);
                                        save.click();
                                        document.body.removeChild(save);

                                    } else {

                                        self.batchProcess = 1;
                                        self.batchNum = data.content;
                                    }
                                }
                                self.action = "list";
                                self.loadList();

                            }else{
                                self.rows = data.content.row;
                                self.totalRecords = data.content.totalRecords;
                            }
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,false,'asset-requisition-list')

                    }
                });
            },

            createPurchaseOrder(id) {

                var self = this;
                // if ( this.$refs['listAssetRequisitionTable'].selectedRows.length != 1 ) {
                //     self.$swal('',"Kindly choose only one requisition.",'info');
                //     return;
                // }

                // if ( this.$refs['listAssetRequisitionTable'].selectedRows[0].po != null ) {
                //     self.$swal('',"Purchase Order has already been created.",'info');
                //     return;
                // }

                if (confirm('Do you want to create PO from this requisition? ')) {
                    this.$router.push({ name: 'VendorPurchaseOrderCreate', params:{requisitionId: id, redirectFrom: 'AssetRequisition'}})
                }

            },

            requisitionDelete() {
                var data = this.$refs['listAssetRequisitionTable'].selectedRows;
                var self = this;
                var use = [];
                for (var i = 0; i < data.length; i++) {
                    use.push(this.$refs['listAssetReadingTable'].selectedRows[i].id)
                }

                if (confirm('Are you sure that you want to delete this Requisition? ')) {
                    self.loading = true;
                    $("#deleteWarrantyBtn").val("Deleting ...");
                    $.ajax({
                        url: process.env.ROOT_API + "/asset-requisition/delete",
                        type: "POST",
                        data: 'ids=' + use,
                        headers: this.ajxHeaders,
                        dataType: 'json',
                        success: function (data) {
                            self.loading = false;
                            setTimeout(function () {
                            $(".alert-success").removeClass("show");
                                $(".alert-success").addClass("hide");
                            }, 10000);
                            setTimeout(function () {
                                $("#deleteWarrantyBtn").val("Delete");
                            }, 10000);
                            self.rows = data.content.row;
                            if (data.code == '200') {
                                self.loadList();
                            }
                        },
                        error: function (jqXHR, exception) {
                            self.loading = false;
                            self.generateStatusCodeMessage(jqXHR,true,'asset-requisition-delete')
                        }
                    });
                }
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/asset/AssetRequisitionList.vue